enum HttpStatusCode {
  Ok = 200,

  NoContent = 204,

  BadRequest = 400,

  Unauthorized = 401,

  RequestForbidden = 403,

  NotFound = 404,

  Conflict = 409,

  InternalServerError = 500,
}

/* eslint-disable import/no-default-export */
export default HttpStatusCode;
